import ReactSimpleCurrency from 'react-simple-currency';
import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../components/Modal';

const CustomTip = ({ close, onChange, onSubmit, tip }) => (
  <Modal title="Custom tip" close={close}>
    <form className="layout layout--flush" onSubmit={onSubmit}>
      <div className="layout__item u-3/4">
        <span className="c-input-prefix">$</span>
        <ReactSimpleCurrency
          className="c-input c-input--prepend"
          type="number"
          min="0"
          placeholder="Enter tip amount"
          required
          value={tip}
          onInputChange={onChange}
        />
      </div>
      <div className="layout__item u-1/4">
        <button className="c-btn c-btn--default u-ph-" disabled={tip < 0}>Set tip</button>
      </div>
    </form>
  </Modal>
);
CustomTip.propTypes = {
  close: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  tip: PropTypes.number.isRequired,
};
CustomTip.defaultProps = {};

export default CustomTip;



// WEBPACK FOOTER //
// ./src/app/reservation/components/CustomTip.jsx